/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

var cn = ls.getSessionEventCollectionName();
const teamRef = con.eventDB.collection(cn).doc('CheckInStaff').collection('Users')
const typeRef = con.eventDB.collection(cn).doc('CheckInStaff').collection('Types')
const sessionRef = con.eventDB.collection(cn).doc('CheckInStaff').collection('Sessions')
const attendeeRef = con.eventDB.collection(cn).doc("AttendeeList").collection("Attendees");
const storageRef = con.storageRef

export default {
    fetchTeams({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            teamRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var data = doc.data();                    
                    markers.push(data)
                })
                commit('SET_TEAMS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting teams:', error)
                reject(error)
            })

        })
    },
    fetchUserDetail(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {                       
                        Email: null,
                        FirstName: null,
                        LastName: null,
                        IsPublished: true,
                        AttendeeId: null, 
                        UserId: null,
                        InvitationStatus: 'NotInvited'
                    }
                })
            } else {
                let docObj = new Object
                teamRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateUser(context, field) {
        //console.log(field)
        return new Promise((resolve, reject) => {
            teamRef.doc(`${field.id}`).update({
                    FirstName: field.data.FirstName,
                    LastName: field.data.LastName,                    
                    IsPublished: field.data.IsPublished,                    
                    LastModifiedDate: new Date()

                })
                .catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    addUser(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                AttendeeId: null,
                UserId: null,
                FirstName: field.data.FirstName,
                LastName: field.data.LastName,    
                Email: field.data.Email.toLowerCase().trim(),                
                IsPublished: field.data.IsPublished,
                InvitationStatus: 'NotInvited',
                CreatedDate: new Date(),                
                LastModifiedDate: new Date()
            }
            let attendeeObj = {
                Name: field.data.FirstName.trim() + ' ' + field.data.LastName.trim(),
                FirstName: field.data.FirstName.trim(),
                LastName: field.data.LastName.trim(),
                Email: field.data.Email.toLowerCase().trim(),
                AttendeeId: null,
                Phone: null,
                PhoneCountryCode: null,
                Country: null,
                FormType: field.data.FormType ? field.data.FormType : 'FREE',
                RegistrationType: field.data.RegistrationType ? field.data.RegistrationType : { ColorCode: "", RegistrationType: "Attendee", RegistrationTypeId: null },
                Company: null,
                Designation: null,
                Profile: null,
                ProfilePictureURL: '',
                Website: null,
                SocialLinks: [
                    { Facebook: '' },
                    { GooglePlus: '' },
                    { LinkedIn: '' },
                    { Twitter: '' }
                ],
                Tags: (field.data.Tags ? field.data.Tags : ''),
                MailSent: false,
                IsVerified: true,
                IsPublished: true,
                UserRoles: [
                    {
                        RoleID: 10,
                        RoleName: "AppUser"
                    },
                    {
                        RoleID: 20,
                        RoleName: "CheckinStaff"
                    }
                ]
            }
            context.dispatch('attendeeManagement/addAttendee', {data:attendeeObj}, {root:true}).then(response => {
                if(response.status == 200 && response.Id){
                    let AutoID = response.Id;
                    docObj.AttendeeId = AutoID;
                    docObj.UserId = AutoID;
                    teamRef.doc(`${AutoID}`).set(docObj).then(function() {
                        resolve({ status: 200, message: 'Data Added.', Id: AutoID })
                    }).catch(function(error) {
                        reject(error)
                    })
                }else if(response.status == 500 && response.AttendeeDetail){
                    let attendeeDetail = response.AttendeeDetail;
                    let UserRoles = [];
                    if(attendeeDetail.UserRoles && attendeeDetail.UserRoles.length)
                        UserRoles = attendeeDetail.UserRoles.filter(item=> item.RoleID != 20);
                    UserRoles.push({RoleID: 20, RoleName: "CheckinStaff"});
                    let AutoID = attendeeDetail.AttendeeId;
                    docObj.AttendeeId = AutoID;
                    docObj.UserId = AutoID;
                    teamRef.doc(`${AutoID}`).set(docObj).then(async function() {
                        await attendeeRef.doc(`${AutoID}`).update({UserRoles: UserRoles}).catch();
                        resolve({ status: 200, message: 'Data Added.', Id: AutoID })
                    }).catch(function(error) {
                        reject(error)
                    })
                }
                else{
                    resolve({ status: 500, message: 'Data Not Added.' })
                }
            }).catch(function(error) {
                reject(error)
            })

        })
    }, 
    updateStatus(context, field) {
        let tasks = [];
        return new Promise(async(resolve, reject) => {
            for(let id of field.userIds){
                tasks.push(teamRef.doc(`${id}`).update({ InvitationStatus: field.status })) 
            }
            try{
                await Promise.all(tasks);
                resolve({ status: 200, message: 'Data Updated.' })
            }catch(err){
                reject(err);
            }
        })
    },  
    setPublishStatus(context, field) {
        let tasks = [];
        return new Promise(async(resolve, reject) => {
            for(let id of field.userIds){
                tasks.push(teamRef.doc(`${id}`).update({ IsPublished: field.status })) 
            }
            try{
                await Promise.all(tasks);
                resolve({ status: 200, message: 'Data Updated.' })
            }catch(err){
                reject(err);
            }
        })
    }, 
    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },  
    fetchTypeList({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            typeRef.get().then(querySnapshot => {                
                for(let doc of querySnapshot.docs){
                    var data = doc.data();                    
                    markers.push(data)
                }               
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting teams:', error)
                reject(error)
            })

        })
    },
    fetchTypeDetail(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {                       
                        CheckInType: 'Custom',
                        DisplayOrder: 1,
                        Name: null,
                        Description: null,
                        IsPublished: true,
                        TypeIconUrl: null, 
                        TypeId: null
                    }
                })
            } else {
                let docObj = new Object
                typeRef.doc(`${id}`).get().then(async function(doc) {
                    let sessions = await context.dispatch('fetchSessionsByTypeId', `${id}`).catch();
                    docObj = doc.data()               
                    docObj.Sessions = sessions;      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    addTypeDetail(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                TypeId: null,
                CheckInType: field.data.CheckInType,
                DisplayOrder: Number(field.data.DisplayOrder),    
                Name: field.data.Name,                
                Description: field.data.Description ? field.data.Description : null,                
                IsPublished: field.data.IsPublished,
                TypeIconUrl: field.data.TypeIconUrl,
                CreatedDate: new Date(),                
                LastModifiedDate: new Date()
            }

            typeRef.add(docObj).then(async function(docRef) {
                if(field.data.CheckInType == 'Session'){
                    context.dispatch('addCheckinSessions', {TypeId: docRef.id,Sessions: field.data.Sessions})
                }
                await typeRef.doc(docRef.id).update({TypeId: docRef.id});
                resolve({ status: 200, message: 'Data Added.', Id: docRef.id })
            }).catch(function(error) {
                reject(error)
            })
            

        })
    }, 
    updateTypeDetail(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                DisplayOrder: Number(field.data.DisplayOrder),    
                Name: field.data.Name,                
                Description: field.data.Description ? field.data.Description : null,               
                IsPublished: field.data.IsPublished,
                TypeIconUrl: field.data.TypeIconUrl,
                LastModifiedDate: new Date()
            }

            if(field.data.CheckInType == 'Session'){
                context.dispatch('addCheckinSessions', {TypeId: field.id,Sessions: field.data.Sessions})
            }
            typeRef.doc(field.id).update(docObj).then(function(docRef) {
                resolve({ status: 200, message: 'Data Updated.' })
            }).catch(function(error) {
                reject(error)
            })
        })
    },
    addCheckinSessions(context, field){
        return new Promise(async(resolve, reject) => {
            await context.dispatch('deleteCheckinSessionsByTypeId', field.TypeId).catch();
            if(field.Sessions && field.TypeId){
                const tasks = [];
                for(let session of field.Sessions){
                    session.TypeId = field.TypeId;
                    tasks.push(sessionRef.doc(`${session.SessionId}`).set(session))
                }
                Promise.all(tasks).then(function(results){
                    resolve({ status: 200, message: `${results.length} Data Added.` })
                }).catch(function(error) {
                    reject(error)
                })
                
            }else{
                reject('Unable to add sessions!');
            }
        });
    },
    deleteCheckinSessionsByTypeId(context, TypeId){
        return new Promise(async(resolve, reject) => {
            if(TypeId){
                const tasks = [];
                sessionRef.get().then(querySnapshot => {
                    for(let doc of querySnapshot.docs){
                        if(doc.data().TypeId == TypeId)
                            tasks.push(sessionRef.doc(`${doc.id}`).delete())
                    }
                    Promise.all(tasks).then(function(results){
                        resolve({ status: 200, message: `${results.length} Data Deleted.` })
                    }).catch(function(error) {
                        reject(error)
                    })
                })
                
            }else{
                reject('Unable to delete sessions!');
            }
        });
    },
    fetchSessionsByTypeId(context, TypeId){
        return new Promise(async(resolve, reject) => {
            if(TypeId){
                const sessions = [];
                sessionRef.get().then(querySnapshot => {
                    for(let doc of querySnapshot.docs){
                        if(doc.data().TypeId == TypeId)
                            sessions.push(doc.data())
                    }
                    resolve(sessions);
                })
                
            }else{
                reject('Unable to fetch sessions!');
            }
        });
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve('')
            }
        })
    },
}